<template>
    <div class="my-security-verification">
        <div class="top">
            {{safetyPage.tip10}}：
            <el-progress color="#f7b800" :percentage="percentage" :format="format"></el-progress>
            <span>
                {{safetyPage.tip11}}
                <label>{{count}}</label>{{safetyPage.tip12}}
            </span>
        </div>
        <el-row>
            <dl class="items">
                <img loading="lazy" v-lazy="require('../../../assets/images/my/verification1.png')" />
                <div class="item1">
                    <h2>{{safetyPage.tip13}}</h2>
                    <p>{{safetyPage.tip14}}</p>
                </div>
                <div
                    :class="userInfo.withdrawPassWordState ? 'btnNoSet' : 'btnSet'" 
                    @click="$router.push({path:'/my/security/capital'})"
                >{{userInfo.withdrawPassWordState ? safetyPage.tip16 :safetyPage.tip17}}</div>
            </dl>
            <dl class="items">
                <img loading="lazy" v-lazy="require('../../../assets/images/my/verification2.png')" />
                <div class="item1">
                    <h2>{{safetyPage.tip18}}</h2>
                    <p>{{safetyPage.tip19}}</p>
                </div>
                <div :class="userInfo.email ? 'btnNoSet' : 'btnSet'"   @click="checkOn(userInfo.email)">{{userInfo.email ? safetyPage.tip27 : safetyPage.tip28 }}</div>
            </dl>
            <dl class="items">
                <img loading="lazy" v-lazy="require('../../../assets/images/my/verification3.png')" />
                <div class="item1">
                    <h2>{{safetyPage.tip20}}</h2>
                    <p>{{safetyPage.tip21}}</p>
                </div>
                <div :class="userInfo.phone ? 'btnNoSet' : 'btnSet'"  @click="checkOn(userInfo.phone)">{{userInfo.phone ? safetyPage.tip27 : safetyPage.tip28}}</div>
            </dl>
            <dl class="items">
                <img loading="lazy" v-lazy="require('../../../assets/images/my/verification4.png')" />
                <div class="item1">
                    <h2>{{safetyPage.tip22}}</h2>
                    <p>{{safetyPage.tip21}}</p>
                </div>
                <div :class="userInfo.qq ? 'btnNoSet' : 'btnSet'"  @click="checkOn(userInfo.qq)">{{userInfo.qq ? safetyPage.tip27 : safetyPage.tip28}}</div>
            </dl>
        </el-row>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    data(){
       return{
            percentage:sessionStorage.getItem('percentage')*1,
            count:sessionStorage.getItem('percentageCount'),
       }
    },
    computed: {
        ...mapGetters(["userInfo"]),
        safetyPage() {
            return this.$t('safetyPage')
        }
    },
    watch: {
        userInfo: {
            handler: function (val) {
                this.updataCount()
            },
            deep: true
        }
    },
    created(){
        this.updataCount()
    },
    methods: {
        updataCount() {
            let count = 0;
            if(this.userInfo.withdrawPassWordState){
                count++;
            }
            if(this.userInfo.email){
                count++;
            }
            if(this.userInfo.phone){
                count++;
            }
            if(this.userInfo.qq){
                count++;
            }
            sessionStorage.setItem('percentage',count * 25);
            sessionStorage.setItem('percentageCount',4 - count);
            this.percentage =  sessionStorage.getItem('percentage')*1;
            this.count = sessionStorage.getItem('percentageCount');
        },
        checkOn(val){
            if(val){
                this.$message({
                    message: this.safetyPage.tip23,
                    type: 'warning'
                }); 
            }else{
                this.$router.push('/my/info/account')
            }
        },
        format(percentage) {
            if (percentage < 60) return this.safetyPage.tip24;
            else if (percentage > 79) return this.safetyPage.tip25;
            else return this.safetyPage.tip26;
        }
    }
};
</script>
<style lang="scss" scoped>
    @import url('../../../assets/css/common.css');
.my-security-verification {
    .top {
        margin-top: 20px;
        margin-bottom: 21px;
        border: 1px solid #dcdcdc;
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        padding: 25px 30px 25px;
        .el-progress {
            width: 350px;
            display: inline-block;
        }
        span {
            float: right;
            label {
                color: #ec2828;
                font-size: 15px;
            }
        }
    }
    .items {
        border-top: 1px solid #e6e6e6;
        padding: 25px 0;
        width: 100%;
        float: left;
        img {
            margin-right: 20px;
            float: left;
            width: 68px;
        }
        .item1 {
            float: left;
            h2 {
                line-height: 30px;
                font-size: 16px;
                font-weight: 200;
                margin-top: 6px;
            }
            p {
                line-height: 24px;
                font-size: 12px;
                font-weight: 200;
                color: #666;
            }
        }
        .btn {
            float: right;
            width: 106px;
            height: 32px;
            border-radius: 4px;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
            box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
            margin-top: 17px;
        }
        .btnSet {
            @extend .btn;
            background: #ff3a2b;
            color: #fff;
        }
        .btnNoSet {
            @extend .btn;
            border: 1px solid #dcdcdc;
            color: #666;
        }
        &:last-of-type {
            border-bottom: 1px solid #e6e6e6;
        }
    }
}
</style>